/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { forEach, get, isArray, isEmpty } from "lodash";
// component
import BillForm from "../../../components/BillForm";
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import DataComponent from "../../../components/DataComponent";
import Comment from "../../../components/Comment";
import { classnames } from "../../../utils/text";
import { translation } from "../../../utils/translator";
import { deleteInvoiceMappingTaxInvoice, deleteToEtcInvoice, getTaxInvoice } from "../../../apis/invoices";
import { autoHyphen } from "../../../utils/replace";
import { transformComma } from "../../../utils/validator/comma";
import { ControlTable } from "../../../components/Table";
import systemAlert from "../../../utils/systemAlert";
import EtcInvoiceMapping from "../Trade/EtcInvoiceMapping";
import { shallowEqual, useSelector } from "react-redux";

// sup 공급자
// byr 공급받는자
const SUP_BYR_TYPE = [{ label: '매출', value: 'sales' }, { label: '매입', value: 'purchase' }];
const INVOICE_TYPE = [
  { label: '전자세금계산서', value: 'tax_invoice' },
  { label: '전자계산서', value: 'invoice' },
  { label: "종이세금계산서", value: "paper_tax_invoice" }
];

const TaxInvoice = ({
  open,
  setOpen,
  list,
  setList,
  type,
  permission,
  submit
}) => {

  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }), shallowEqual);

  const [fields] = useState([
    [
      {
        title: "작성일자",
        key: "writeDate",
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        textAlign: "right",
        transform: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        textAlign: "right",
        transform: 'comma'
      },
      {
        title: "합계",
        key: "totalAmt",
        transform: 'comma'
      },
    ],
    [
      {
        title: "비고",
        key: "remark",
        className: "remark",
      },
      {
        title: "영수/청구",
        key: "demandType",
        className: "demandType",
      },
    ],
  ]);
  // 품목 리스트
  const [itemList] = useState(
    [
      {
        title: "월",
        key: "trMonth",
        textAlign: "center",
      },
      {
        title: "일",
        key: "trDate",
        textAlign: "center",
      },
      {
        title: "품목",
        key: "itemName",
        className: "prod-name",
      },
      {
        title: "규격",
        key: "itemStd",
        textAlign: "center",
      },
      {
        title: "수량",
        key: "itemQty",
        textAlign: "center",
      },
      {
        title: "단가",
        key: "itemUnitCost",
        textAlign: "center",
        transform: 'comma'
      },
      {
        title: "공급가액",
        key: "itemSupAmt",
        textAlign: "center",
        transform: 'comma'
      },
      {
        title: "세액",
        key: "itemTaxAmt",
        textAlign: "center",
        transform: 'comma'
      },
      {
        title: "비고",
        key: "itemRemark",
        textAlign: "center",
      },
    ],
  );
  const [formValue, setFormValue] = useState({});
  // 연관된 거래명세서
  const [mappedInvoiceFields, setMappedInvoiceFields] = useState([]);
  const [mappedInvoiceData, setMappedInvoiceData] = useState([]);

  // 매핑된 견적서 / 발주서
  const [mappedEtcInvoiceFields, setMappedEtcInvoiceFields] = useState([]);
  const [mappedEtcInvoiceData, setMappedEtcInvoiceData] = useState([]);

  // 발주서/견적서 매핑하기
  const [isEtcInvoiceMapping, setIsEtcInvoiceMapping] = useState(false);
  const [etcInvoiceMappingData, setEtcInvoiceMappingData] = useState(null);

  const [invoicePermission, setInvoicePermission] = useState({});

  useEffect(() => {
    if (!isEmpty(list)) {
      setInvoice(list);
    }
  }, [list]);


  useEffect(() => {
    if (!isEmpty(permissions)) {
      setInvoicePermission(permissions.find(p => p.code === "TRADE_INVOICE"));
    }
  }, [permissions]);


  useEffect(() => {
    setMappedInvoiceFields([
      { title: "일자", key: "writeDate" },
      { title: "상호", key: type === 'sales' ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: type === 'sales' ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: type === 'sales' ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        title: "대표품목",
        key: "items[0].prodName",
        onValue: (value, field, form) => {
          let items = "";
          if (!isEmpty(form.invoiceItems)) {
            forEach(form.invoiceItems, (item) => {
              if (item.order === 1) {
                items =
                  form.invoiceItems.length > 1
                    ? `${item.prodName} 외 ${form.invoiceItems.length - 1}건`
                    : item.prodName;
              }
            });
          }

          return items;
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        onValue: (value) => {
          return transformComma(value);
        },
      },
      {
        title: "세액",
        key: "taxAmt",
        onValue: (value) => {
          return transformComma(value);
        },
      },
      {
        title: "합계금액",
        key: "totalAmt",
        onValue: (value) => {
          return transformComma(value);
        },
      },
      /*
      {
        title: "발행여부",
        key: "taxInvoiceIdx",
        onValue: (value, field, form) => {
          let issue = "";
          if (isNull(value) && !form.invoiceToTaxInvoice) {
            issue = "부";
          } else {
            // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
            issue = "세금계산서"
          }

          return issue;
        },
      },
      */
    ]);

    setMappedEtcInvoiceFields([
      { title: "구분", key: "etcInvoiceType", onValue: (value) => value === "quotation" ? "견적서" : "발주서" },
      { title: "작성일자", key: "writeDate", type: "date" },
      {
        title: "상호",
        onValue: (_value, _field, data) => {
          return data.supByrType === "sales" ? data["byrCorpName"] : data["supCorpName"];
        }
      },
      {
        title: "대표자명",
        onValue: (_value, _field, data) => {
          return data.supByrType === "sales" ? data["byrRepName"] : data["supRepName"];
        }
      },
      {
        title: "사업자번호",
        onValue: (_value, _field, data) => {
          const value = data.supByrType === "sales" ? data["byrBizNo"] : data["supBizNo"];
          return autoHyphen("comNum", value);
        }
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: "comma"
      },
      {
        title: "세액",
        key: "taxAmt",
        type: "comma"
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: "comma"
      },
    ]);
  }, [type]);

  const setInvoice = (data) => {
    getTaxInvoice(data.idx).then((res) => {

      const taxInvoiceItems = [];
      forEach(res.data.taxInvoiceItems, item => {
        const date = item.itemDate.split('-');
        taxInvoiceItems.push({ ...item, trMonth: date[1] || "", trDate: date[2] || "" });
      });

      setFormValue({
        ...res.data,
        byrEmail: res.data.byrEmail1,
        taxInvoiceItems
      });

      setMappedEtcInvoiceData(res?.data?.mappedEtcInvoices || []);
      setMappedInvoiceData(res.data.mappedInvoices);
    });
  };

  const cancel = (e) => {
    setOpen(false);
    setList({});
  };

  const mappedInvoiceRowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        // 거래처 매핑
        type: "delete",
        action: (data) => {
          systemAlert('연관 거래명세서를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteInvoiceMappingTaxInvoice({ idxes: [data.invoiceToTaxInvoice.idx] })
                    .then(() => {
                      setInvoice(list);
                    })
                    .catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const mappedEtcInvoiceRowBtnConfig = {
    title: "삭제",
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert(`연관 견적서/발주서를 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "확인",
                onClick: () => {
                  deleteToEtcInvoice("taxInvoice", { idx: [data.etcInvoiceToTaxInvoice?.idx] })
                    .then(() => {
                      setInvoice(list);
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ]
  };



  return (
    <>
      <Modal isOpen={open} close={cancel} size="x-lg" className="p-0">
        <div className="tax-invoice-write">
          <ModalHeader>{translation(SUP_BYR_TYPE, get(formValue, 'supByrType'))} {`${formValue?.invoiceType === "paper_tax_invoice" ? "종이" : "전자"}`}(세금)계산서</ModalHeader>
          <div className="header-button-wrap">
            <Button
              className="print-button print-out"
              color="gray-line"
              label="인쇄"
              onClick={() => window.print()}
            />
            {permission.level > 1 && (
              <Button
                className="print-button print-out ml-8"
                color="gray-line"
                label="견적서/발주서 매핑"
                disabled={isEmpty(invoicePermission)}
                onClick={() => {
                  setIsEtcInvoiceMapping(true);
                  setEtcInvoiceMappingData(list);
                }}
              />
            )}
          </div>
          <div className="tax-invoice-body">
            <div className="bill-form-header">
              <div className="invoice-title-wrap">
                {`${translation(SUP_BYR_TYPE, get(formValue, 'supByrType'))} ${translation(INVOICE_TYPE, get(formValue, 'invoiceType'))}`}
              </div>
              <div className="issue-no-wrap">
                <div className="issue-no-label-wrap">
                  승인번호
                </div>
                <div className="issue-no">
                  {get(formValue, 'issueNoDisp')}
                </div>
              </div>
            </div>
            <div className="bill-form-body">
              <div className="invoicer-bill">
                <BillForm
                  type="sup"
                  form={formValue}
                  formType="detail"
                  invoiceType="tax-invoice"
                />
              </div>
              <div className="invoicee-bill">
                <BillForm
                  type="byr"
                  form={formValue}
                  formType="detail"
                  invoiceType="tax-invoice"
                />
              </div>
              {isArray(fields) &&
                fields.map((_fields, index) => (
                  <table className="bill-additional-form" key={index}>
                    <tbody>
                      <tr>
                        {isArray(_fields) &&
                          _fields.map((field, idx) => (
                            <td className="bill-item-wrap" key={idx}>
                              <span className="additional-form-title">
                                {field.title}
                              </span>
                              <span className={classnames("additional-form-input", field.className)}>
                                <DataComponent
                                  field={field}
                                  form={formValue}
                                  className={field.className}
                                />
                              </span>
                            </td>
                          ))}
                      </tr>
                    </tbody>
                  </table>
                ))}
            </div>
            <div className="item-list-container">
              <div className="item-list">
                <table>
                  <thead>
                    <tr>
                      {itemList.map((item, idx) => (
                        <th key={idx}>
                          <span className="item-table-header">{item.title}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(formValue) &&
                      formValue.taxInvoiceItems.map((invoiceItem, idx) => (
                        <tr key={idx}>
                          {itemList.map((item, idx) => (
                            <td key={idx}>
                              <DataComponent
                                field={item}
                                form={invoiceItem}
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            {!isEmpty(mappedInvoiceData) && (
              <div className="mapped-invoice-container">
                <label className="related-header-title">
                  연관 거래명세서
                </label>
                <ControlTable
                  fields={mappedInvoiceFields}
                  list={mappedInvoiceData}
                  rowBtn={permission.level > 1 ? mappedInvoiceRowBtnConfig : {}} />
              </div>
            )}

            {!isEmpty(mappedEtcInvoiceData) && (
              <div className="mapped-invoice-container">
                <label className="related-header-title">
                  연관 견적서/발주서
                </label>
                <ControlTable
                  fields={mappedEtcInvoiceFields}
                  list={mappedEtcInvoiceData}
                  rowBtn={permission.level > 1 ? mappedEtcInvoiceRowBtnConfig : {}}
                />
              </div>
            )}
            <div className="file-upload-list">
              <label className="file-upload-label">첨부파일</label>
              <div className="file-upload-form">
                <Comment
                  postIdx={list.idx}
                  postType="tax_invoice_detail"
                  submit={submit}
                />
              </div>
            </div>
            <div className="submit-button-wrap float-right">
              <Button
                className="button print-out"
                size="lg"
                label="닫기"
                action={cancel}
              />
            </div>
          </div>
        </div>
      </Modal>

      {/* 견적서or발주서 매핑하기 */}
      {isEtcInvoiceMapping && (
        <EtcInvoiceMapping
          open={isEtcInvoiceMapping}
          setOpen={setIsEtcInvoiceMapping}
          data={etcInvoiceMappingData}
          setData={setEtcInvoiceMappingData}
          listSubmit={() => setInvoice(list)}
          requesterType={"taxInvoice"}
        />
      )}
    </>
  );
};

export default TaxInvoice;
